export default __webpack_public_path__ + "static/media/newTopbarLogo.5dc6c4b7.svg";